'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Schools = function () {
  function Schools($http) {
    _classCallCheck(this, Schools);

    this._ = { $http: $http };
    this.prefix = IFEIS_API_URI + '/api/schools';
  }

  _createClass(Schools, [{
    key: 'all',
    value: function all() {
      var _this = this;

      return this._.$http.get(this.prefix).then(function (school_objs) {
        return school_objs.map(function (s) {
          return new School(_this._.$http, s);
        });
      });
    }
  }, {
    key: 'one',
    value: function one(id) {
      var _this2 = this;

      return this._.$http.get(this.prefix + '/' + id).then(function (school_obj) {
        return new School(_this2._.$http, school_obj);
      });
    }
  }, {
    key: 'create',
    value: function create(props) {
      var _this3 = this;

      return this._.$http.post(this.prefix, props).then(function (school_obj) {
        return new School(_this3._.$http, school_obj);
      });
    }
  }]);

  return Schools;
}();

var School = function () {
  function School($http, school) {
    _classCallCheck(this, School);

    this._ = { $http: $http };
    this.data = school;
    this.prefix = IFEIS_API_URI + '/api/schools/' + school.id;
  }

  _createClass(School, [{
    key: 'get',
    value: function get() {
      return this.data;
    }
  }, {
    key: 'delete',
    value: function _delete() {
      return this._.$http.delete(this.prefix);
    }
  }, {
    key: 'update',
    value: function update(props) {
      var _this4 = this;

      return this._.$http.put(this.prefix, props).then(function (school_obj) {
        _this4.data = school_obj;
        return _this4;
      });
    }
  }, {
    key: 'teachers',
    value: function teachers() {
      return this._.$http.get(this.prefix + '/teachers');
    }
  }, {
    key: 'feis',
    value: function feis(fid) {
      return this._.$http.get(this.prefix + '/feiseanna/' + fid);
    }
  }, {
    key: 'addTeacher',
    value: function addTeacher(email) {
      return this._.$http.post(this.prefix + '/teachers', { email: email });
    }
  }, {
    key: 'feiseanna',
    value: function feiseanna() {
      return this._.$http.get(this.prefix + '/feiseanna');
    }
  }, {
    key: 'rmTeacher',
    value: function rmTeacher(id) {
      return this._.$http.delete(this.prefix + '/teachers/' + id);
    }
  }]);

  return School;
}();

exports.default = angular.module('ifeis.schools', []).factory('fSchoolService', ['$http', function ($http) {
  return new Schools($http);
}]);


//////////////////
// WEBPACK FOOTER
// ./schools/index.js
// module id = 605
// module chunks = 0